import {
  getStockAlerts,
  removeStockAlert,
  setStockAlertFilters,
  updateStockAlert,
} from '@state/reducers/stockAlertReducer'
import { GridColumns } from '@mui/x-data-grid-pro'
import { StockAlertDto } from '@services/dtos'
import StockAlertForm from '@components/forms/StockAlertForm'
import { useEffect, useMemo } from 'react'
import BaseConfigTable from './BaseConfigTable'
import { useAppDispatch } from '@hooks/reduxHooks'
import { AppDispatch } from '@state/store'

export default function StockAlertsTable() {
  const dispatch = useAppDispatch()
  useEffect(() => {
    return () => {
      dispatch(setStockAlertFilters({ includeInactive: false }))
    }
  }, [])
    
  const columns: GridColumns<StockAlertDto> = useMemo(
    () => [
      { field: 'productGenericName', headerName: 'DCI', width: 250 },
      { field: 'thresholdUnits', headerName: 'Seuil quantité', width: 200 },
    ],
    [],
  )

  return (
    <BaseConfigTable<StockAlertDto>
      columns={columns}
      selectRows={(state) => state.stockAlert.items}
      fetchThunk={() => async (dispatch: AppDispatch) => {
        dispatch(setStockAlertFilters({ includeInactive: true }))
        return dispatch(getStockAlerts())
      }}
      deleteThunk={removeStockAlert}
      toggleThunk={(id, isActive) => updateStockAlert({ id, dto: { isActive } })}
      updatePageThunk={(page) => async (dispatch: AppDispatch) => {
        dispatch(setStockAlertFilters({ page }))
        dispatch(getStockAlerts())
      }}
      FormComponent={({ editingItem, onClose }) => (
        <StockAlertForm editingStockAlert={editingItem} onClose={onClose} />
      )}
      resourceLabel="alerte de stock"
      resourcePrefix="l'"
    />
  )
}
